import type { SVGProps } from "react";
export interface HoneyPotIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HoneyPotIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HoneyPotIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 11.473c0-1.69.268-3.295 1-4.718.65-1.262 1.634-2.321 3-3.16V2a1.125 1.125 0 0 1 2.25 0v2.25c0 .418-.232.802-.602.996-1.317.694-2.14 1.551-2.648 2.539-.517 1.004-.75 2.222-.75 3.688 0 1.845.786 4.273 2.017 6.248.61.977 1.296 1.792 1.99 2.35.702.561 1.336.803 1.868.803h6c.533 0 1.166-.242 1.867-.804.695-.557 1.381-1.372 1.99-2.35 1.231-1.974 2.018-4.402 2.018-6.247 0-1.466-.233-2.684-.75-3.688-.509-.988-1.331-1.845-2.649-2.539-.37-.194-.6-.578-.6-.996V2a1.125 1.125 0 0 1 2.25 0v1.595c1.365.839 2.35 1.898 3 3.16.732 1.423.998 3.027.998 4.718 0 2.366-.962 5.202-2.356 7.439-.703 1.127-1.548 2.155-2.494 2.913-.94.754-2.056 1.3-3.274 1.3H9c-1.217 0-2.334-.546-3.273-1.3-.946-.758-1.79-1.786-2.494-2.913C1.84 16.675.875 13.839.875 11.473"
      />
      <path
        fill={color}
        d="M11.874 7.5V3.125H5a1.125 1.125 0 0 1 0-2.25h14l.115.006a1.125 1.125 0 0 1 0 2.238L19 3.125h-2.875V6a1.119 1.119 0 0 1-2.001.697V7.5a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
